import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Invoice } from '../../invoices/invoice.model';
import { Product, Summary } from '../../../../../shared/models/models';

@Component({
	selector: 'product-package-table',
	template: require('./product-package-table.html'),
	styles: [require('./product-package-table.scss')],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ProductPackageTableComponent),
			multi: true
		}
	]
})
export class ProductPackageTableComponent implements OnInit {
	@Input('data') data: Product[];
	@Input('summary') summary: Summary;
	@Input('invoice') invoice: Invoice;
	@Input('currencySymbol') currencySymbol: string;
	hasDiscount: boolean;

	constructor() {}

	ngOnInit(): void {
		this.hasDiscount =
			this.summary.discountValue && this.summary.discountValue > 0;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quotes/product-package-table/product-package-table.ts